import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTURESERVERSTAFF,
    RETRIEVE_ARCHITECTURESERVERSTAFF,
    RETRIEVESINGLE_ARCHITECTURESERVERSTAFF,
    UPDATE_ARCHITECTURESERVERSTAFF,
    DELETE_ARCHITECTURESERVERSTAFF,
    RETRIEVE_ARCHITECTURESERVERADMIN,
} from "./type";
import ARCServerStaff from "../service/arcServerStaff";
import ARCServerAdmin from "../service/arcServerAdmin";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCServerStaff.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCServerStaff.create(data);
        dispatch({
            type: CREATE_ARCHITECTURESERVERSTAFF,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCServerStaff.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVERSTAFF,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveAdmin = (data) => async (dispatch) => {
    try {
        const res = await ARCServerAdmin.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVERADMIN,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCServerStaff.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTURESERVERSTAFF,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCServerStaff.update(data);
        dispatch({
            type: UPDATE_ARCHITECTURESERVERSTAFF,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const updateEmail = (data) => async (dispatch) => {
    try {
        const res = await ARCServerStaff.updateEmail(data);
        // dispatch({
        //     type: UPDATE_ARCHITECTURESERVERSTAFF,
        //     status: '',
        //     response: {},
        //     payload: res.data,
        // });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const updatePhone = (data) => async (dispatch) => {
    try {
        const res = await ARCServerStaff.updatePhone(data);
        // dispatch({
        //     type: UPDATE_ARCHITECTURESERVERSTAFF,
        //     status: '',
        //     response: {},
        //     payload: res.data,
        // });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const changeStatus = (data) => async (dispatch) => {
    try {
        const res = await ARCServerStaff.changeStatus(data);
        dispatch({
            type: UPDATE_ARCHITECTURESERVERSTAFF,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCServerStaff.trash(data);
        dispatch({
            type: DELETE_ARCHITECTURESERVERSTAFF,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};